var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"text-center"},[_c('h1',[_vm._v("ошибка 404")]),_c('v-btn',{on:{"click":function($event){return _vm.$router.push({
              name:'order-today',
              replace:true
      })}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }